// // /* eslint-disable jsx-a11y/click-events-have-key-events */
// // /* eslint-disable jsx-a11y/no-static-element-interactions */
// // /* eslint-disable react/prop-types */
// // import React, { useState } from 'react';
// // import { IoIosEye } from 'react-icons/io';

// // const styles = {
// //   overlay: {
// //     position: 'fixed',
// //     top: 0,
// //     left: 0,
// //     width: '100vw',
// //     height: '100vh',
// //     backgroundColor: 'rgba(0, 0, 0, 0.6)',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     zIndex: 9999,
// //   },
// //   modal: {
// //     position: 'relative',
// //     backgroundColor: '#fff',
// //     padding: '20px',
// //     borderRadius: '8px',
// //     maxWidth: '90vw',
// //     maxHeight: '90vh',
// //   },
// //   fechar: {
// //     position: 'absolute',
// //     top: '5px',
// //     right: '10px',
// //     border: 'none',
// //     background: 'transparent',
// //     fontSize: '28px',
// //     cursor: 'pointer',
// //     zIndex: 2,
// //   },
// //   carouselContainer: {
// //     position: 'relative',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //   },
// //   navButton: {
// //     position: 'absolute',
// //     top: '50%',
// //     transform: 'translateY(-50%)',
// //     border: 'none',
// //     // backgroundColor: 'rgba(0, 0, 0, 0.45)',
// //     backgroundColor: 'transparent',
// //     color: '#555',
// //     fontSize: '32px',
// //     // width: '25px',
// //     // height: '25px',
// //     borderRadius: '50%',
// //     cursor: 'pointer',
// //     zIndex: 1,
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //   },
// //   prevButton: {
// //     left: '10px',
// //   },
// //   nextButton: {
// //     right: '10px',
// //   },
// //   contador: {
// //     marginTop: '10px',
// //     textAlign: 'center',
// //     fontSize: '14px',
// //     color: '#555',
// //   },
// // };

// // function ImagePreviewModal({
// //   imagePath,
// //   imagePaths,
// //   title = 'Imagem da peça',
// //   iconSize = 25,
// //   iconColor = '#ccc',
// //   imageSize = 500,
// // }) {
// //   const [modalAberto, setModalAberto] = useState(false);
// //   const [imagemAtual, setImagemAtual] = useState(0);

// //   const imagens = imagePaths || (imagePath ? [imagePath] : []);
// //   const possuiMaisDeUmaImagem = imagens.length > 1;

// //   function abrirModal() {
// //     setImagemAtual(0);
// //     setModalAberto(true);
// //   }

// //   function fecharModal() {
// //     setModalAberto(false);
// //   }

// //   function imagemAnterior(e) {
// //     e.stopPropagation();

// //     setImagemAtual((indiceAtual) =>
// //       indiceAtual === 0 ? imagens.length - 1 : indiceAtual - 1
// //     );
// //   }

// //   function proximaImagem(e) {
// //     e.stopPropagation();

// //     setImagemAtual((indiceAtual) =>
// //       indiceAtual === imagens.length - 1 ? 0 : indiceAtual + 1
// //     );
// //   }

// //   if (!imagens.length) {
// //     return null;
// //   }

// //   return (
// //     <>
// //       <span style={{ margin: '10px', cursor: 'pointer' }} onClick={abrirModal}>
// //         <IoIosEye
// //           size={iconSize}
// //           color={iconColor}
// //           title={title}
// //           style={{
// //             transform: 'translateY(7px)',
// //           }}
// //         />
// //       </span>

// //       {modalAberto && (
// //         <div style={styles.overlay} onClick={fecharModal}>
// //           <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
// //             <button type="button" style={styles.fechar} onClick={fecharModal}>
// //               ×
// //             </button>

// //             <div style={styles.carouselContainer}>
// //               {possuiMaisDeUmaImagem && (
// //                 <button
// //                   type="button"
// //                   style={{
// //                     ...styles.navButton,
// //                     ...styles.prevButton,
// //                   }}
// //                   onClick={imagemAnterior}
// //                 >
// //                   ‹
// //                 </button>
// //               )}

// //               <img
// //                 src={imagens[imagemAtual]}
// //                 alt={`${title} ${imagemAtual + 1}`}
// //                 style={{
// //                   width: `${imageSize}px`,
// //                   height: `${imageSize}px`,
// //                   maxWidth: '80vw',
// //                   maxHeight: '80vh',
// //                   objectFit: 'contain',
// //                   display: 'block',
// //                 }}
// //               />

// //               {possuiMaisDeUmaImagem && (
// //                 <button
// //                   type="button"
// //                   style={{
// //                     ...styles.navButton,
// //                     ...styles.nextButton,
// //                   }}
// //                   onClick={proximaImagem}
// //                 >
// //                   ›
// //                 </button>
// //               )}
// //             </div>

// //             {possuiMaisDeUmaImagem && (
// //               <div style={styles.contador}>
// //                 {imagemAtual + 1} / {imagens.length}
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // }

// // export default ImagePreviewModal;

// /* eslint-disable jsx-a11y/click-events-have-key-events */
// /* eslint-disable jsx-a11y/no-static-element-interactions */
// /* eslint-disable react/prop-types */
// import React, { useState, useEffect } from 'react';
// import { IoIosEye } from 'react-icons/io';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// const styles = {
//   overlay: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100vw',
//     height: '100vh',
//     backgroundColor: 'rgba(0, 0, 0, 0.6)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//   },
//   modal: {
//     position: 'relative',
//     backgroundColor: '#fff',
//     padding: '20px',
//     borderRadius: '8px',
//     maxWidth: '90vw',
//     maxHeight: '90vh',
//   },
//   fechar: {
//     position: 'absolute',
//     top: '5px',
//     right: '10px',
//     border: 'none',
//     background: 'transparent',
//     fontSize: '28px',
//     cursor: 'pointer',
//     zIndex: 2,
//   },
//   carouselContainer: {
//     position: 'relative',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   navButton: {
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     border: 'none',
//     // backgroundColor: 'rgba(0, 0, 0, 0.45)',
//     backgroundColor: 'transparent',
//     color: '#555',
//     fontSize: '32px',
//     // width: '25px',
//     // height: '25px',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     zIndex: 1,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   prevButton: {
//     left: '10px',
//   },
//   nextButton: {
//     right: '10px',
//   },
//   contador: {
//     marginTop: '10px',
//     textAlign: 'center',
//     fontSize: '14px',
//     color: '#555',
//   },
// };

// function ImagePreviewModal({
//   // novo modo (dinâmico via endpoint)
//   imagens: imagensMeta = [],
//   idEmpresa,
//   idCatalogo,
//   idPagina,
//   idItem,
//   idMaterial,
//   // modo antigo (compatibilidade)
//   imagePath,
//   imagePaths,
//   title = 'Imagem da peça',
//   iconSize = 25,
//   iconColor = '#ccc',
//   imageSize = 500,
// }) {
//   const [modalAberto, setModalAberto] = useState(false);
//   const [imagemAtual, setImagemAtual] = useState(0);
//   const [imagensSrc, setImagensSrc] = useState([]);
//   const [carregando, setCarregando] = useState(false);

//   const usaEndpoint = imagensMeta.length > 0;

//   // fallback estático
//   const imagensEstaticas = imagePaths || (imagePath ? [imagePath] : []);

//   // total de imagens disponíveis (para mostrar/ocultar o ícone e as setas)
//   const totalImagens = usaEndpoint
//     ? imagensMeta.length
//     : imagensEstaticas.length;

//   const possuiMaisDeUmaImagem = totalImagens > 1;

//   // lista de URLs realmente exibidas no carrossel
//   const imagens = usaEndpoint ? imagensSrc : imagensEstaticas;

//   // busca as imagens no endpoint ao abrir o modal
//   useEffect(() => {
//     if (!modalAberto || !usaEndpoint) return undefined;

//     let cancelado = false;
//     const urlsCriadas = [];

//     async function carregarImagens() {
//       setCarregando(true);
//       try {
//         const urls = await Promise.all(
//           imagensMeta.map((img) =>
//             api
//               .get(
//                 `/empresa/${idEmpresa}/catalogo/${idCatalogo}/pagina/${idPagina}/item/${idItem}/material/${idMaterial}/${img.numeroFormatado}`,
//                 { responseType: 'blob' }
//               )
//               .then((res) => {
//                 const url = URL.createObjectURL(res.data);
//                 urlsCriadas.push(url);
//                 return url;
//               })
//               .catch(() => {
//                 toast.error('Não foi possível carregar a imagem');
//               })
//           )
//         );

//         if (!cancelado) setImagensSrc(urls);
//       } catch (err) {
//         console.error('Erro ao carregar imagens da peça', err);
//       } finally {
//         if (!cancelado) setCarregando(false);
//       }
//     }

//     carregarImagens();

//     // libera os object URLs ao fechar/desmontar
//     return () => {
//       cancelado = true;
//       urlsCriadas.forEach((url) => URL.revokeObjectURL(url));
//     };
//   }, [
//     modalAberto,
//     usaEndpoint,
//     imagensMeta,
//     idEmpresa,
//     idCatalogo,
//     idPagina,
//     idItem,
//     idMaterial,
//   ]);

//   function abrirModal() {
//     setImagemAtual(0);
//     setModalAberto(true);
//   }

//   function fecharModal() {
//     setModalAberto(false);
//   }

//   function imagemAnterior(e) {
//     e.stopPropagation();
//     setImagemAtual((i) => (i === 0 ? imagens.length - 1 : i - 1));
//   }

//   function proximaImagem(e) {
//     e.stopPropagation();
//     setImagemAtual((i) => (i === imagens.length - 1 ? 0 : i + 1));
//   }

//   // sem nenhuma imagem para mostrar -> não renderiza o ícone
//   if (!totalImagens) {
//     return null;
//   }

//   return (
//     <>
//       <span style={{ margin: '10px', cursor: 'pointer' }} onClick={abrirModal}>
//         <IoIosEye
//           size={iconSize}
//           color={iconColor}
//           title={title}
//           style={{ transform: 'translateY(7px)' }}
//         />
//       </span>

//       {modalAberto && (
//         <div style={styles.overlay} onClick={fecharModal}>
//           <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//             <button type="button" style={styles.fechar} onClick={fecharModal}>
//               ×
//             </button>

//             <div style={styles.carouselContainer}>
//               {possuiMaisDeUmaImagem && imagens.length > 0 && (
//                 <button
//                   type="button"
//                   style={{ ...styles.navButton, ...styles.prevButton }}
//                   onClick={imagemAnterior}
//                 >
//                   ‹
//                 </button>
//               )}

//               {carregando || imagens.length === 0 ? (
//                 <div
//                   style={{
//                     width: `${imageSize}px`,
//                     height: `${imageSize}px`,
//                     maxWidth: '80vw',
//                     maxHeight: '80vh',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     color: '#555',
//                   }}
//                 >
//                   Carregando imagens...
//                 </div>
//               ) : (
//                 <img
//                   src={imagens[imagemAtual]}
//                   alt={`${title} ${imagemAtual + 1}`}
//                   style={{
//                     width: `${imageSize}px`,
//                     height: `${imageSize}px`,
//                     maxWidth: '80vw',
//                     maxHeight: '80vh',
//                     objectFit: 'contain',
//                     display: 'block',
//                   }}
//                 />
//               )}

//               {possuiMaisDeUmaImagem && imagens.length > 0 && (
//                 <button
//                   type="button"
//                   style={{ ...styles.navButton, ...styles.nextButton }}
//                   onClick={proximaImagem}
//                 >
//                   ›
//                 </button>
//               )}
//             </div>

//             {possuiMaisDeUmaImagem && imagens.length > 0 && (
//               <div style={styles.contador}>
//                 {imagemAtual + 1} / {imagens.length}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ImagePreviewModal;

// /* eslint-disable jsx-a11y/click-events-have-key-events */
// /* eslint-disable jsx-a11y/no-static-element-interactions */
// /* eslint-disable react/prop-types */
// import React, { useState } from 'react';
// import { IoIosEye } from 'react-icons/io';

// const styles = {
//   overlay: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100vw',
//     height: '100vh',
//     backgroundColor: 'rgba(0, 0, 0, 0.6)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//   },
//   modal: {
//     position: 'relative',
//     backgroundColor: '#fff',
//     padding: '20px',
//     borderRadius: '8px',
//     maxWidth: '90vw',
//     maxHeight: '90vh',
//   },
//   fechar: {
//     position: 'absolute',
//     top: '5px',
//     right: '10px',
//     border: 'none',
//     background: 'transparent',
//     fontSize: '28px',
//     cursor: 'pointer',
//     zIndex: 2,
//   },
//   carouselContainer: {
//     position: 'relative',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   navButton: {
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     border: 'none',
//     // backgroundColor: 'rgba(0, 0, 0, 0.45)',
//     backgroundColor: 'transparent',
//     color: '#555',
//     fontSize: '32px',
//     // width: '25px',
//     // height: '25px',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     zIndex: 1,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   prevButton: {
//     left: '10px',
//   },
//   nextButton: {
//     right: '10px',
//   },
//   contador: {
//     marginTop: '10px',
//     textAlign: 'center',
//     fontSize: '14px',
//     color: '#555',
//   },
// };

// function ImagePreviewModal({
//   imagePath,
//   imagePaths,
//   title = 'Imagem da peça',
//   iconSize = 25,
//   iconColor = '#ccc',
//   imageSize = 500,
// }) {
//   const [modalAberto, setModalAberto] = useState(false);
//   const [imagemAtual, setImagemAtual] = useState(0);

//   const imagens = imagePaths || (imagePath ? [imagePath] : []);
//   const possuiMaisDeUmaImagem = imagens.length > 1;

//   function abrirModal() {
//     setImagemAtual(0);
//     setModalAberto(true);
//   }

//   function fecharModal() {
//     setModalAberto(false);
//   }

//   function imagemAnterior(e) {
//     e.stopPropagation();

//     setImagemAtual((indiceAtual) =>
//       indiceAtual === 0 ? imagens.length - 1 : indiceAtual - 1
//     );
//   }

//   function proximaImagem(e) {
//     e.stopPropagation();

//     setImagemAtual((indiceAtual) =>
//       indiceAtual === imagens.length - 1 ? 0 : indiceAtual + 1
//     );
//   }

//   if (!imagens.length) {
//     return null;
//   }

//   return (
//     <>
//       <span style={{ margin: '10px', cursor: 'pointer' }} onClick={abrirModal}>
//         <IoIosEye
//           size={iconSize}
//           color={iconColor}
//           title={title}
//           style={{
//             transform: 'translateY(7px)',
//           }}
//         />
//       </span>

//       {modalAberto && (
//         <div style={styles.overlay} onClick={fecharModal}>
//           <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//             <button type="button" style={styles.fechar} onClick={fecharModal}>
//               ×
//             </button>

//             <div style={styles.carouselContainer}>
//               {possuiMaisDeUmaImagem && (
//                 <button
//                   type="button"
//                   style={{
//                     ...styles.navButton,
//                     ...styles.prevButton,
//                   }}
//                   onClick={imagemAnterior}
//                 >
//                   ‹
//                 </button>
//               )}

//               <img
//                 src={imagens[imagemAtual]}
//                 alt={`${title} ${imagemAtual + 1}`}
//                 style={{
//                   width: `${imageSize}px`,
//                   height: `${imageSize}px`,
//                   maxWidth: '80vw',
//                   maxHeight: '80vh',
//                   objectFit: 'contain',
//                   display: 'block',
//                 }}
//               />

//               {possuiMaisDeUmaImagem && (
//                 <button
//                   type="button"
//                   style={{
//                     ...styles.navButton,
//                     ...styles.nextButton,
//                   }}
//                   onClick={proximaImagem}
//                 >
//                   ›
//                 </button>
//               )}
//             </div>

//             {possuiMaisDeUmaImagem && (
//               <div style={styles.contador}>
//                 {imagemAtual + 1} / {imagens.length}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ImagePreviewModal;

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { IoIosEye } from 'react-icons/io';
import { toast } from 'react-toastify';
import api from '../../services/api';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modal: {
    position: 'relative',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '90vw',
    maxHeight: '90vh',
  },
  fechar: {
    position: 'absolute',
    top: '5px',
    right: '10px',
    border: 'none',
    background: 'transparent',
    fontSize: '28px',
    cursor: 'pointer',
    zIndex: 2,
  },
  carouselContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    border: 'none',
    // backgroundColor: 'rgba(0, 0, 0, 0.45)',
    backgroundColor: 'transparent',
    color: '#555',
    fontSize: '32px',
    // width: '25px',
    // height: '25px',
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  prevButton: {
    left: '10px',
  },
  nextButton: {
    right: '10px',
  },
  contador: {
    marginTop: '10px',
    textAlign: 'center',
    fontSize: '14px',
    color: '#555',
  },
};

function ImagePreviewModal({
  /**
   * Modo dinâmico (via endpoint).
   *
   * Recebe apenas idEmpresa e idMaterial: a foto pertence ao material
   * (MATERIAL_FABRICANTE), e a mesma peça aparece em catálogos
   * diferentes. Catálogo, página e item foram retirados porque faziam a
   * mesma peça ter imagem em um catálogo e nenhuma em outro, conforme
   * onde o upload tivesse sido feito.
   */
  imagens: imagensMeta = [],
  idEmpresa,
  idMaterial,
  // modo antigo (compatibilidade)
  imagePath,
  imagePaths,
  title = 'Imagem da peça',
  iconSize = 25,
  iconColor = '#ccc',
  imageSize = 500,
}) {
  const [modalAberto, setModalAberto] = useState(false);
  const [imagemAtual, setImagemAtual] = useState(0);
  const [imagensSrc, setImagensSrc] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const usaEndpoint = imagensMeta.length > 0;

  // fallback estático
  const imagensEstaticas = imagePaths || (imagePath ? [imagePath] : []);

  // total de imagens disponíveis (para mostrar/ocultar o ícone e as setas)
  const totalImagens = usaEndpoint
    ? imagensMeta.length
    : imagensEstaticas.length;

  const possuiMaisDeUmaImagem = totalImagens > 1;

  // lista de URLs realmente exibidas no carrossel
  const imagens = usaEndpoint ? imagensSrc : imagensEstaticas;

  // busca as imagens no endpoint ao abrir o modal
  useEffect(() => {
    if (!modalAberto || !usaEndpoint) return undefined;

    let cancelado = false;
    const urlsCriadas = [];

    async function carregarImagens() {
      setCarregando(true);
      try {
        const urls = await Promise.all(
          imagensMeta.map((img) =>
            api
              .get(
                `/empresa/${idEmpresa}/material/${idMaterial}/imagem/${img.numeroFormatado}`,
                { responseType: 'blob' }
              )
              .then((res) => {
                const url = URL.createObjectURL(res.data);
                urlsCriadas.push(url);
                return url;
              })
              .catch(() => {
                toast.error('Não foi possível carregar a imagem');
                return null;
              })
          )
        );

        /**
         * Descarta as que falharam: sem isso a lista ficava com posições
         * undefined, o carrossel exibia imagem quebrada e o contador
         * mostrava um total que não existia.
         */
        if (!cancelado) setImagensSrc(urls.filter((url) => !!url));
      } catch (err) {
        console.error('Erro ao carregar imagens da peça', err);
      } finally {
        if (!cancelado) setCarregando(false);
      }
    }

    carregarImagens();

    // libera os object URLs ao fechar/desmontar
    return () => {
      cancelado = true;
      urlsCriadas.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [modalAberto, usaEndpoint, imagensMeta, idEmpresa, idMaterial]);

  function abrirModal() {
    setImagemAtual(0);
    setModalAberto(true);
  }

  function fecharModal() {
    setModalAberto(false);
  }

  function imagemAnterior(e) {
    e.stopPropagation();
    setImagemAtual((i) => (i === 0 ? imagens.length - 1 : i - 1));
  }

  function proximaImagem(e) {
    e.stopPropagation();
    setImagemAtual((i) => (i === imagens.length - 1 ? 0 : i + 1));
  }

  // sem nenhuma imagem para mostrar -> não renderiza o ícone
  if (!totalImagens) {
    return null;
  }

  return (
    <>
      <span style={{ margin: '10px', cursor: 'pointer' }} onClick={abrirModal}>
        <IoIosEye
          size={iconSize}
          color={iconColor}
          title={title}
          style={{ transform: 'translateY(7px)' }}
        />
      </span>

      {modalAberto && (
        <div style={styles.overlay} onClick={fecharModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button type="button" style={styles.fechar} onClick={fecharModal}>
              ×
            </button>

            <div style={styles.carouselContainer}>
              {possuiMaisDeUmaImagem && imagens.length > 0 && (
                <button
                  type="button"
                  style={{ ...styles.navButton, ...styles.prevButton }}
                  onClick={imagemAnterior}
                >
                  ‹
                </button>
              )}

              {carregando || imagens.length === 0 ? (
                <div
                  style={{
                    width: `${imageSize}px`,
                    height: `${imageSize}px`,
                    maxWidth: '80vw',
                    maxHeight: '80vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#555',
                  }}
                >
                  Carregando imagens...
                </div>
              ) : (
                <img
                  src={imagens[imagemAtual]}
                  alt={`${title} ${imagemAtual + 1}`}
                  style={{
                    width: `${imageSize}px`,
                    height: `${imageSize}px`,
                    maxWidth: '80vw',
                    maxHeight: '80vh',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              )}

              {possuiMaisDeUmaImagem && imagens.length > 0 && (
                <button
                  type="button"
                  style={{ ...styles.navButton, ...styles.nextButton }}
                  onClick={proximaImagem}
                >
                  ›
                </button>
              )}
            </div>

            {possuiMaisDeUmaImagem && imagens.length > 0 && (
              <div style={styles.contador}>
                {imagemAtual + 1} / {imagens.length}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ImagePreviewModal;
